import { render, staticRenderFns } from "./RecommendationCurrentlyAvailableCard.vue?vue&type=template&id=df11d05a&"
import script from "./RecommendationCurrentlyAvailableCard.vue?vue&type=script&lang=js&"
export * from "./RecommendationCurrentlyAvailableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports